// Utils
import {
  localMobilePhoneValidator,
  prettifyPhoneNumber,
} from '@shopee-user/authentication-utils';

// Types
import { TypedFormConfig } from '@shopee/use-form-hook';
import { LoginByOtpFormShape } from '@shopee-user/business-customization-types';

export const FORM_CONFIG: TypedFormConfig<LoginByOtpFormShape> = {
  authKey: {
    type: 'string',
    initialValue: '',
    validators: [localMobilePhoneValidator('msg_auth_invalid_phone')],
    transform: prettifyPhoneNumber,
  },
};
